import request from '../request';

//职业规划内容问题获取
export const getPlanningIssues = ( cv_token) => {
  return request({
    url: `/v3/career_path_issues/${cv_token}`,
    method: 'get'
  })
}

//职业规划内容问题修改
export const updatePlanningIssues = ( cv_token, params) => {
  return request({
    url: `/v3/career_path_issues/${cv_token}`,
    method: 'put',
    data: params
  })
}
//获取经历
export const getExperience = (cv_token) => {
  return request({
    url: `/v3/cvs/${cv_token}/online_cv_format`,
    method: 'get'
  })
}

//获取简历预测的信息数据
export const getPredictiveLevel = (query) => {
  return request({
    url: `/v3/career_path_reports/predict_level`,
    method: 'get',
    params: query
  })
}
//获取简历预测的信息数据对应的其他用户
export const getPredictiveLevelToUser = (query) => {
  return request({
    url: `/v3/career_path_reports/predict_user`,
    method: 'get',
    params: query
  })
}
//获取随机公司
export const getRandomCompany = (query) => {
  return request({
    url: `/v3/career_path_issues/random_companies`,
    method: 'get'
  })
}
//获取某个人的报告
export const getReports = (query) => {
  return request({
    url: `/v3/career_path_reports`,
    method: 'POST',
    data: query
  })
}

//获取对应职类方向
export const getJobDirections = (query) => {
  return request ({
    url:'/v3/career_path_reports/career_directions',
    method:'POST',
    data:query
  })
}

//公司增强
export const getCompanyDetail = (query) => {
  return request({
    url: `/v3/companies/full_info`,
    method: 'get',
    params: query
  })
}

//职位推荐
export const getRecommendList = (params) => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT)  + `/v1/jobs/cvs_jobs_recommend`,
    method: 'get',
    params
  })
}

//获取职类详情
export const getProfession = (profession_id) => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v1/salary_distributions/${profession_id}`,
    method: 'get'
  })
}
//获取职类所需要的技能
export const getProfessionSkill = (profession_id) => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/host' : process.env.API) + `/static/v2/professions/skills/${profession_id}`,
    method: 'get'
  })
}
//根据职类获取有相关职位的公司
export const getProfessionCompany = (profession_id) => {
  return request({
    url: `/v3/companies/level2_jobs`,
    method: 'get',
    params: {profession_id}
  })
}

// 职业规划反馈
export const feedback = data => {
  return request({
    url: '/v3/career_path_feedbacks',
    method: 'POST',
    data
  })
}
